import { Injectable } from '@angular/core';
import { DropdownModel } from 'src/app/shared/models/dropdown.model';

@Injectable({
    providedIn: 'root'
})
export class CountryService {

    private countryLists = [new DropdownModel('US', 'USA')];

    private stateLists =
       [
         new DropdownModel('AL', 'Alabama'),
         new DropdownModel('AK', 'Alaska'),
         new DropdownModel('AZ', 'Arizona'),
         new DropdownModel('AR', 'Arkansas'),
         new DropdownModel('CA', 'California'),
         new DropdownModel('CO', 'Colorado'),
         new DropdownModel('CT', 'Connecticut'),
         new DropdownModel('DE', 'Delaware'),
         new DropdownModel('DC', 'District Of Columbia'),
         new DropdownModel('FL', 'Florida'),
         new DropdownModel('GA', 'Georgia'),
         new DropdownModel('HI', 'Hawaii'),
         new DropdownModel('ID', 'Idaho'),
         new DropdownModel('IL', 'Illinois'),
         new DropdownModel('IN', 'Indiana'),
         new DropdownModel('IA', 'Iowa'),
         new DropdownModel('KS', 'Kansas'),
         new DropdownModel('KY', 'Kentucky'),
         new DropdownModel('LA', 'Louisiana'),
         new DropdownModel('ME', 'Maine'),
         new DropdownModel('MD', 'Maryland'),
         new DropdownModel('MA', 'Massachusetts'),
         new DropdownModel('MI', 'Michigan'),
         new DropdownModel('MN', 'Minnesota'),
         new DropdownModel('MS', 'Mississippi'),
         new DropdownModel('MO', 'Missouri'),
         new DropdownModel('MT', 'Montana'),
         new DropdownModel('NE', 'Nebraska'),
         new DropdownModel('NV', 'Nevada'),
         new DropdownModel('NH', 'New Hampshire'),
         new DropdownModel('NJ', 'New Jersey'),
         new DropdownModel('NM', 'New Mexico'),
         new DropdownModel('NY', 'New York'),
         new DropdownModel('NC', 'North Carolina'),
         new DropdownModel('ND', 'North Dakota'),
         new DropdownModel('OH', 'Ohio'),
         new DropdownModel('OK', 'Oklahoma'),
         new DropdownModel('OR', 'Oregon'),
         new DropdownModel('PA', 'Pennsylvania'),
         new DropdownModel('RI', 'Rhode Island'),
         new DropdownModel('SC', 'South Carolina'),
         new DropdownModel('SD', 'South Dakota'),
         new DropdownModel('TN', 'Tennessee'),
         new DropdownModel('TX', 'Texas'),
         new DropdownModel('UT', 'Utah'),
         new DropdownModel('VT', 'Vermont'),
         new DropdownModel('VA', 'Virginia'),
         new DropdownModel('WA', 'Washington'),
         new DropdownModel('WV', 'West Virginia'),
         new DropdownModel('WI', 'Wisconsin'),
         new DropdownModel('WY', 'Wyoming'),
       ];

    getCountryLists(): DropdownModel[] {
      return this.countryLists;
    }

    getStateLists(): DropdownModel[] {
      return this.stateLists;
    }
}
